export const automationTimer = 'timer';
export const automationMotion = 'motion';
export const automationType = [automationTimer, automationMotion] as const;
export type AutomationType = typeof automationType[number];

export const automationMotionScenarioTrigger = 'scenario';
export const automationMotionGroupTrigger = 'group';
export const automationMotionTriggerType = [automationMotionScenarioTrigger, automationMotionGroupTrigger] as const;
export type AutomationMotionTriggerType = typeof automationMotionTriggerType[number];
